import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from './pages/Home';
import BlogsPage from './pages/Blogs';
import Navbar from './components/Header/navbar';
import Footer from './components/footer';
import BookingPage from './pages/Booking';
import Exhibits from './pages/Exhibits';
import BlogDetails from './pages/Blogs/blogDetails';
import ContactUs from './pages/contactUs';
import ExhibitsDetails from './pages/Exhibits/exhibits-details';
import Gallery from './pages/gallery';
import Feedback from './pages/feedback';
import ProceedTopay from './pages/proceedToPay';
import TicketDetails from './pages/Booking/ticketDetails';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import AboutMusuem from './components/Home/aboutMuseum';
import EventsPage from './pages/events';
import Maps from './pages/Maps';
import LoginPage from './pages/Login';
import ProfilePage from './pages/Profile';
import HelpSupport from './pages/HelpSupport';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';

import { useIsAppWebView } from "./hooks/useIsAppWebView";

function AppOnlyRoute({ children }) {
  const isApp = useIsAppWebView();
  if (!isApp) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  const queryClient = new QueryClient()
  const [language, setLanguage] = useState('en');

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  return (
    <>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="*" element={
                  <>
                    <Navbar language={language} onLanguageChange={handleLanguageChange}/>
                    <Routes>
                      <Route path="/" element={<Home language={language} />} />
                      <Route path="/home" element={<Home language={language} />} />
                      <Route path="/booking" element={<BookingPage language={language} />} />
                      <Route path="/about" element={<AboutMusuem language={language} />} />
                      <Route path="/events" element={<EventsPage language={language} />} />
                      <Route path="/ticket-details" element={<TicketDetails language={language}/>} />
                      <Route path="/blogs" element={<BlogsPage />} />
                      <Route path="/blogs/blog_listing" element={<BlogDetails />} />
                      <Route path="/main-attractions" element={<Exhibits language={language} />} />
                      <Route path="/exhibits-details" element={<ExhibitsDetails />} />
                      <Route path="/blogDetails" element={<BlogDetails />} />
                      <Route path="/blog/:id" element={<BlogDetails />} />
                      <Route path="/contact-us" element={<ContactUs language={language}/>} />
                      <Route path="/gallery" element={<Gallery language={language} />} />
                      <Route path="/feedback" element={<Feedback language={language} />} />
                      <Route path="/procced-to-pay" element={<ProceedTopay />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/help" element={<HelpSupport language={language} />} />
                      <Route path="/maps" element={<AppOnlyRoute><Maps language={language} /></AppOnlyRoute>} />
                      <Route path="/*" element={<Home language={language} />} />
                    </Routes>
                    <Footer language={language}/>
                  </>
                } />
              </Routes>
            </BrowserRouter>
          </QueryClientProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
